/* eslint-disable @typescript-eslint/consistent-type-definitions */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import * as React from "react";
import { Grid, GridColumn } from "semantic-ui-react";
import "./project-show.css"
import LabeledValue from "../../../components/labeled-value/labeled-value";
import LabeledTextArea from "../../../components/labeled-textarea/labeled-textarea";
import { LandUsePlanChangeProject } from "../../../stores/project/project";
import { getDesc, getLabel } from "../../../reflection/reflection";

export default function LandUsePlanChangeShow({ project }: { project: LandUsePlanChangeProject }): JSX.Element {
    return (
        <div>
            <Grid columns={2} relaxed={true} stackable={true}>
                <GridColumn largeScreen={16} widescreen={8}>
                    <LabeledValue
                        label={getLabel(project, "fullType")}
                        value={project.type}
                    />
                    <LabeledValue
                        label={getLabel(project, "municipalityName")}
                        desc={getDesc(project, "municipalityName")}
                        value={project.municipalityName}/>
                    <LabeledValue
                        label={getLabel(project, "place")}
                        desc={getDesc(project, "place")}
                        value={project.place}/>
                    <LabeledValue
                        label={getLabel(project, "revision")}
                        desc={getDesc(project, "revision")}
                        value={project.revision}/>
                    <LabeledValue
                        label={getLabel(project, "status")}
                        value={project.status}/>
                    <LabeledValue
                        label={getLabel(project, "governmentCouncilDecisionNr")}
                        desc={getDesc(project, "governmentCouncilDecisionNr")}
                        value={project.governmentCouncilDecisionNr}/>
                    <LabeledValue
                        label={getLabel(project, "ebageNr")}
                        desc={getDesc(project, "ebageNr")}
                        value={project.ebageNr}/>
                    <LabeledValue
                        label={getLabel(project, "enactmentDateDisplayText")}
                        desc={getDesc(project, "enactmentDateDisplayText")}
                        value={project.enactmentDateDisplayText}/>
                    <LabeledValue
                        label={getLabel(project, "targetArea")}
                        desc={getDesc(project, "targetArea")}
                        value={project.targetArea?.toLocaleString()}/>
                    <LabeledValue
                        label={getLabel(project, "compensationDeadlineDisplayText")}
                        desc={getDesc(project, "compensationDeadlineDisplayText")}
                        value={project.compensationDeadlineDisplayText}/>
                    <LabeledValue
                        label={getLabel(project, "cmiDocumentsRawiPre")}
                        desc={getDesc(project, "cmiDocumentsRawiPre")}
                        value={project.cmiDocumentsRawiPre.join(", ")}/>
                    <LabeledValue
                        label={getLabel(project, "cmiDocumentsUwePre")}
                        desc={getDesc(project, "cmiDocumentsUwePre")}
                        value={project.cmiDocumentsUwePre.join(", ")}/>
                    <LabeledValue
                        label={getLabel(project, "cmiDocumentsRawiApproved")}
                        desc={getDesc(project, "cmiDocumentsRawiApproved")}
                        value={project.cmiDocumentsRawiApproved.join(", ")}/>
                    <LabeledValue
                        label={getLabel(project, "cmiDocumentsUweApproved")}
                        desc={getDesc(project, "cmiDocumentsUweApproved")}
                        value={project.cmiDocumentsUweApproved.join(", ")}/>
                </GridColumn>
                <GridColumn>
                    <LabeledValue
                        label={getLabel(project, "geometrySource")}
                        desc={getDesc(project, "geometrySource")}
                        value={project.geometrySource}
                    />
                    <LabeledValue
                        label={getLabel(project, "geometrySourceDateDisplayText")}
                        desc={getDesc(project, "geometrySourceDateDisplayText")}
                        value={project.geometrySourceDateDisplayText}
                    />
                    <LabeledTextArea
                        label={getLabel(project, "remarks")}
                        name="remarks"
                        defaultValue={project.remarks}
                        disabled={true}/>
                </GridColumn>
            </Grid>
        </div>
    );
}
